export interface VideoShotsListParams {
  firstCategory?: string
  keyword?: string
  pageIndex?: number
  pageSize?: number
}

export interface VideoShotsListItem {
  description: string
  id: number
  materialId: number
  mutedVideoUrl: string
  tag: string
  videoUrl: string
}

export interface VideoShotsListResult {
  items: VideoShotsListItem[]
  pageIndex: number
  pageSize: number
  total: number
}

export interface VideoShotsListResponse {
  code?: number
  cost?: string
  data?: null | {
    list?: null | VideoShotsListItem[]
    pageIndex?: number
    pageSize?: number
    total?: number
  }
  msg?: string
  traceID?: string
  list?: null | VideoShotsListItem[]
  pageIndex?: number
  pageSize?: number
  total?: number
}

export const normalizeVideoShotsListResponse = (
  response: VideoShotsListResponse,
  params: VideoShotsListParams,
): VideoShotsListResult => {
  const payload =
    response?.data && typeof response.data === 'object'
      ? response.data
      : response
  const items = Array.isArray(payload?.list) ? payload.list : []

  return {
    items,
    pageIndex: Number(payload?.pageIndex || params.pageIndex || 1),
    pageSize: Number(payload?.pageSize || params.pageSize || 20),
    total: Number(payload?.total || 0),
  }
}
